/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { initializeFirebase } from './push-notification.js'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered(registration) {
      console.log('Service worker has been registered.')
      initializeFirebase(registration)
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      console.log('New content is available; please refresh.')
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })

  window.addEventListener('load', () => {
    // When the user asks to refresh the UI, we'll need to reload the window
    const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (!iOS) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        // ошибка в этом if на ios - Андрей!
        if (!event.data) {
          return
        }

        switch (event.data) {
          case 'reload-window':
            window.location.reload()
            break;
          default:
            break
        }
      })
    }
  })
}